import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea, Box, Grid } from '@mui/material';
import PageBanner from '../../../../common/components/PageBanner';
import "../styles/Aboutus.css";
import "../styles/Ourhistory.css";
import { data } from '../data/ValuesComponentData';
// TODO(refresh): set to the supplied Our Mission & Values header banner.
import MISSION_BANNER from '../../../../assets/new-images/values_and_mission.png';

export default function OurValuesComponents() {
  return (
    <Grid container sx={{ marginBottom: "0px" }}>
      <Grid item xs={12}>
        <PageBanner
          image={MISSION_BANNER}
          alt="Volunteers and families packing emergency supply boxes together in a community hall."
          eyebrow="About Us / Our Mission"
          title="Our Mission & Values"
        />
      </Grid>
      <Grid container item xs={12} md={12} lg={12}>
        <div className='ourhistory-header-container'>
          <Grid container item xs={12} md={12} lg={12} className='ourhistory-mission-title-container'>
            <Grid item xs={12} md={12} lg={12}>
              <Typography component="h2" className='primary-font-bold-heading' sx={{ textAlign: "center", marginBottom: "30px" }}>Our Mission</Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box>
                <p className="mrf-callout" style={{ textAlign: "center", borderLeft: 0, padding: 0 }}>Help families turn preparedness into a practical plan they can understand, use, and update.</p>
                <Typography className='primary-font-normal-11' style={{ textAlign: "center", letterSpacing: '0.11px' }}>MYREDFOLDER, Inc. offers the platform; NEPTA helps bring the program to households and organizations.</Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid container item xs={12} md={12} lg={12} sx={{ background: "#FAFAFB" }}>
        <div className='ourhistory-header-container'>
          <Grid item xs={12} md={12} lg={12}  className='ourhistory-values-title-container' >
            <Typography component="h2" className='primary-font-bold-heading' sx={{ textAlign: "center" }}>
              Our Values
            </Typography>
          </Grid>
          <Grid container spacing={2} item xs={12} md={12} lg={12} >

            <Grid container spacing={5} item xs={12} md={12} lg={12} >
              {data.map((item, i) => (
                <Grid item xs={12} sm={6} md={6} lg={4}>
                  <Item key={i} item={item} />
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
            <Box sx={{ marginY: "40px" }}>
              <Typography className='primary-font-normal-11' style={{ letterSpacing: '0.11px' }}> These values guide us in fulfilling our mission and drive our commitment to making a positive difference in the lives of individuals, families, and communities affected by disasters.</Typography>
            </Box>
          </Grid>
          </Grid>
        </div>
        
      </Grid>
    </Grid>
  )
}

function Item(props) {
  return (


    <Card sx={{ ":hover": { boxShadow: 4 } }}
 className='Ourvalues-middle-top-container'
    >
      <Box   className='Ourvalues-middle-values-img-container'>
        <CardMedia sx={{ height: "80px", width: "80px" }}
          component="img"
          image={props.item.image}
          alt=""
        />
      </Box>
      <CardContent>
        <Typography component="h3" className='primary-font-bold5' sx={{ textAlign: "center" }}>
          {props.item.title}
        </Typography>
        <Typography sx={{ color: "#000000", opacity: "60%", mt: "20px", px: "10px" }} className='primary-font-normal-19'>
          {props.item.content}
        </Typography>
      </CardContent>
    </Card>

  );
}

